/* @flow */

import * as React from 'react';

type Props = {
  className?: string,
};

const defaultProps = {
  className: undefined,
};

function FriendIcon({
  className,
}: Props) {
  return (
    <svg className={className} viewBox="0 0 38 38">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle fill="currentColor" cx="19" cy="19" r="19" />
        <path d="M23.3484955,22.5268744 C24.873464,22.988986 26.1558047,23.9016429 27.1955559,25.2648723 C28.2353072,26.6281017 28.9631221,28.1183895 29.3790226,29.7357803 L9,29.7357803 C9.4159005,28.1183895 10.1437155,26.6281017 11.1834667,25.2648723 C12.223218,23.9016429 13.5055586,22.988986 15.0305271,22.5268744 C16.3706509,23.266253 17.7569651,23.6359368 19.1895113,23.6359368 C20.6220575,23.6359368 22.0083717,23.266253 23.3484955,22.5268744 L23.3484955,22.5268744 Z M19.1895113,7C21.1765915,7 22.8979316,7.71626234 24.3535834,9.14880851 C25.8092351,10.5813547 26.5370501,12.3142474 26.5370501,14.3475388 C26.5370501,16.3808301 25.8092351,18.1137229 24.3535834,19.546269 C22.8979316,20.9788152 21.1765915,21.6950775 19.1895113,21.6950775 C17.2024311,21.6950775 15.481091,20.9788152 14.0254392,19.546269 C12.5697875,18.1137229 11.8419725,16.3808301 11.8419725,14.3475388 C11.8419725,12.3142474 12.5697875,10.5813547 14.0254392,9.14880851C15.481091,7.71626234 17.2024311,7 19.1895113,7 L19.1895113,7 Z M19.1895113,19.9621674 C20.3447905,19.9621674 21.3845261,19.6271415 22.3087495,18.9570796 C23.2329728,18.2870177 23.9030247,17.4436765 24.3189252,16.4270309 L14.0600975,16.4270309 C14.475998,17.4436765 15.1460498,18.2870177 16.0702732,18.9570796 C16.9944965,19.6271415 18.0342321,19.9621674 19.1895113,19.9621674 L19.1895113,19.9621674 Z" fill="white" />
      </g>
    </svg>
  );
}

FriendIcon.defaultProps = defaultProps;

export default FriendIcon;
